/** Rota deep-link do Novo Painel do Técnico (overlay sobre o Board). */
export const TECHNICIAN_PANEL_ROUTE = '/app/roteiro';

export const TECHNICIAN_PANEL_LAYOUTS = {
  modal: 'modal',
  fullscreen: 'fullscreen',
  sidebar: 'sidebar',
};

export const TECHNICIAN_PANEL_LAYOUT_DEFAULT = TECHNICIAN_PANEL_LAYOUTS.modal;

const LAYOUT_KEY = 'painelOs.technicianPanel.layout';
const TECH_KEY = 'painelOs.technicianPanel.openTechnician';

export function isTechnicianPanelLayout(value) {
  return (
    value === TECHNICIAN_PANEL_LAYOUTS.modal ||
    value === TECHNICIAN_PANEL_LAYOUTS.fullscreen ||
    value === TECHNICIAN_PANEL_LAYOUTS.sidebar
  );
}

export function getTechnicianPanelLayout() {
  try {
    const raw = localStorage.getItem(LAYOUT_KEY);
    if (isTechnicianPanelLayout(raw)) return raw;
  } catch {
    /* ignore */
  }
  return TECHNICIAN_PANEL_LAYOUT_DEFAULT;
}

export function setTechnicianPanelLayout(layout) {
  const next = isTechnicianPanelLayout(layout) ? layout : TECHNICIAN_PANEL_LAYOUT_DEFAULT;
  try {
    localStorage.setItem(LAYOUT_KEY, next);
  } catch {
    /* ignore */
  }
  return next;
}

export function rememberTechnicianPanelTechnician(technician) {
  const name = technician != null ? String(technician).trim() : '';
  try {
    if (name) sessionStorage.setItem(TECH_KEY, name);
    else sessionStorage.removeItem(TECH_KEY);
  } catch {
    /* ignore */
  }
  return name;
}

export function getRememberedTechnicianPanelTechnician() {
  try {
    const raw = sessionStorage.getItem(TECH_KEY);
    return raw != null && String(raw).trim() !== '' ? String(raw).trim() : null;
  } catch {
    return null;
  }
}

export function clearRememberedTechnicianPanelTechnician() {
  try {
    sessionStorage.removeItem(TECH_KEY);
  } catch {
    /* ignore */
  }
}

export function technicianPanelLayoutClass(layout) {
  if (layout === TECHNICIAN_PANEL_LAYOUTS.fullscreen) return 'tp-layout-fullscreen';
  if (layout === TECHNICIAN_PANEL_LAYOUTS.sidebar) return 'tp-layout-sidebar';
  return 'tp-layout-modal';
}
